<ng-container [formGroup]="form | bgoAsFormGroup" *transloco="let t">
  <form [formGroup]="optionsForm">
    <label for="numberOfLamps" class="mt-xs font-bold">
      {{ t('createJobRequest.installLampsForm.numberOfLampsLabel') }}
    </label>
    <cft-number-input
      id="numberOfLamps"
      [formControl]="form.controls.numberOfLamps | bgoAsFormControl"
      [min]="1"
      [max]="100"
      [step]="1"
      [hasWarning]="numberOfLamps > 7"
      [label]="t('createJobRequest.installLampsForm.amount')"
    >
      <span content="error">
        {{ t('createJobRequest.installLampsForm.errors.numberOfLampsRequired') }}
      </span>
    </cft-number-input>
    @if (numberOfLamps > 7) {
      <span class="warning" [innerHTML]="t('createJobRequest.priceRange.maxLampsExceededWarning')"></span>
    }
    <div
      class="gradual-reveal mt-2xl space-y-md"
      [class.gradual-reveal-hidden]="!numberOfLamps || numberOfLamps === 1"
      [formGroup]="lampTypeForm"
    >
      <label class="font-bold">{{ t('createJobRequest.installLampsForm.typeOfLamps.label') }}</label>
      <bgo-option-count
        [optionCount]="lampTypeCount"
        [itemCount]="form.controls.numberOfLamps.value"
      ></bgo-option-count>
      <div>
        <cft-checkbox [formControl]="lampTypeOptionControls.ceiling | bgoAsFormControl">
          {{ t('createJobRequest.installLampsForm.typeOfLamps.ceiling') }}
        </cft-checkbox>
        @if (lampTypeOptionControls.ceiling.value) {
          <cft-number-input
            class="block py-sm"
            id="numberOfCeilingLamps"
            [formControl]="lampTypeControls.ceiling | bgoAsFormControl"
            [max]="lampTypeControls.ceiling.value + (numberOfLamps - lampTypeCount)"
            [min]="0"
          ></cft-number-input>
        }
      </div>
      <div>
        <cft-checkbox [formControl]="lampTypeOptionControls.hanging | bgoAsFormControl">
          {{ t('createJobRequest.installLampsForm.typeOfLamps.hanging') }}
        </cft-checkbox>
        @if (lampTypeOptionControls.hanging.value) {
          <cft-number-input
            [formControl]="lampTypeControls.hanging | bgoAsFormControl"
            [max]="lampTypeControls.hanging.value + (numberOfLamps - lampTypeCount)"
            [min]="0"
          ></cft-number-input>
        }
      </div>
      <div>
        <cft-checkbox [formControl]="lampTypeOptionControls.wall | bgoAsFormControl">
          {{ t('createJobRequest.installLampsForm.typeOfLamps.wall') }}
        </cft-checkbox>
        @if (lampTypeOptionControls.wall.value) {
          <cft-number-input
            [formControl]="lampTypeControls.wall | bgoAsFormControl"
            [max]="lampTypeControls.wall.value + (numberOfLamps - lampTypeCount)"
            [min]="0"
          ></cft-number-input>
        }
      </div>
      <div>
        <cft-checkbox [formControl]="lampTypeOptionControls.chandelier | bgoAsFormControl">
          {{ t('createJobRequest.installLampsForm.typeOfLamps.chandelier') }}
        </cft-checkbox>
        @if (lampTypeOptionControls.chandelier.value) {
          <cft-number-input
            [formControl]="lampTypeControls.chandelier | bgoAsFormControl"
            [max]="lampTypeControls.chandelier.value + (numberOfLamps - lampTypeCount)"
            [min]="0"
          ></cft-number-input>
        }
      </div>
      <div>
        <cft-checkbox [formControl]="lampTypeOptionControls.pendant | bgoAsFormControl">
          {{ t('createJobRequest.installLampsForm.typeOfLamps.pendant') }}
        </cft-checkbox>
        @if (lampTypeOptionControls.pendant.value) {
          <cft-number-input
            [formControl]="lampTypeControls.pendant | bgoAsFormControl"
            [max]="lampTypeControls.pendant.value + (numberOfLamps - lampTypeCount)"
            [min]="0"
          ></cft-number-input>
        }
      </div>
      <div>
        <cft-checkbox [formControl]="lampTypeOptionControls.other | bgoAsFormControl">
          {{ t('createJobRequest.installLampsForm.typeOfLamps.other') }}
        </cft-checkbox>
        @if (lampTypeOptionControls.other.value) {
          <cft-number-input
            [formControl]="lampTypeControls.other | bgoAsFormControl"
            [max]="lampTypeControls.other.value + (numberOfLamps - lampTypeCount)"
            [hasWarning]="lampTypeControls.other.value"
            [min]="0"
          ></cft-number-input>
        }
      </div>
      @if (lampTypeControls.other.value) {
        <span class="warning" [innerHTML]="t('createJobRequest.priceRange.unknownInputWarning')"> </span>
      }
      @if (optionControls.lampTypeOptions.touched && optionControls.lampTypeOptions.errors?.atLeastOneOptionSelected) {
        <span class="error">
          {{ t('createJobRequest.installLampsForm.errors.atLeastOneOptionSelected') }}
        </span>
      }
      @if (
        !optionControls.lampTypeOptions.errors?.atLeastOneOptionSelected &&
        form.controls.lampTypes.touched &&
        form.controls.lampTypes.errors?.notAllLampsAccountedFor
      ) {
        <span class="error">
          {{ t('createJobRequest.installLampsForm.errors.notAllLampsAccountedFor') }}
        </span>
      }
    </div>
    <div class="gradual-reveal mt-2xl space-y-md" [class.gradual-reveal-hidden]="!numberOfLamps || numberOfLamps > 1">
      <label class="font-bold">{{ t('createJobRequest.installLampsForm.typeOfLamps.label') }}</label>
      <cft-radio class="mt-xs block" [formControl]="optionControls.lampTypeSingleSelect" [value]="'ceiling'">
        {{ t('createJobRequest.installLampsForm.typeOfLamps.ceiling') }}
      </cft-radio>
      <cft-radio [formControl]="optionControls.lampTypeSingleSelect" [value]="'hanging'">
        {{ t('createJobRequest.installLampsForm.typeOfLamps.hanging') }}
      </cft-radio>
      <cft-radio [formControl]="optionControls.lampTypeSingleSelect" [value]="'wall'">
        {{ t('createJobRequest.installLampsForm.typeOfLamps.wall') }}
      </cft-radio>
      <cft-radio [formControl]="optionControls.lampTypeSingleSelect" [value]="'chandelier'">
        {{ t('createJobRequest.installLampsForm.typeOfLamps.chandelier') }}
      </cft-radio>
      <cft-radio [formControl]="optionControls.lampTypeSingleSelect" [value]="'pendant'">
        {{ t('createJobRequest.installLampsForm.typeOfLamps.pendant') }}
      </cft-radio>
      <cft-radio
        [formControl]="optionControls.lampTypeSingleSelect"
        [value]="'other'"
        [hasWarning]="lampTypeControls.other.value"
      >
        {{ t('createJobRequest.installLampsForm.typeOfLamps.other') }}
      </cft-radio>
      @if (lampTypeControls.other.value) {
        <span class="warning" [innerHTML]="t('createJobRequest.priceRange.unknownInputWarning')"> </span>
      }
    </div>
    <div
      class="gradual-reveal mt-2xl space-y-md"
      [class.gradual-reveal-hidden]="lampTypeCount !== form.controls.numberOfLamps.value"
    >
      <label class="font-bold">{{ t('createJobRequest.installLampsForm.lampWeight.label') }}</label>
      <cft-radio
        class="mt-xs block"
        [formControl]="form.controls.heaviestLampWeight | bgoAsFormControl"
        [value]="lampWeight.Under_10Kg"
      >
        {{ t('createJobRequest.installLampsForm.lampWeight.under10') }}
      </cft-radio>
      <cft-radio [formControl]="form.controls.heaviestLampWeight | bgoAsFormControl" [value]="lampWeight.MoreThan_10Kg">
        {{ t('createJobRequest.installLampsForm.lampWeight.above10') }}
      </cft-radio>
      @if (form.controls.heaviestLampWeight.value === lampWeight.MoreThan_10Kg) {
        <span class="text-sm text-grey-700" [innerHTML]="t('createJobRequest.installLampsForm.lampWeight.above10Hint')">
        </span>
      }
      @if (form.controls.heaviestLampWeight.touched && form.controls.heaviestLampWeight.invalid) {
        <span class="error">
          {{ t('createJobRequest.installLampsForm.errors.atLeastOneOptionSelected') }}
        </span>
      }
    </div>
    <div
      class="gradual-reveal mt-2xl space-y-md"
      [class.gradual-reveal-hidden]="!form.controls.heaviestLampWeight.value"
    >
      <label class="font-bold">{{ t('createJobRequest.installLampsForm.roomHeight.label') }}</label>
      <cft-radio
        class="mt-xs block"
        [formControl]="form.controls.highestRoomCeiling | bgoAsFormControl"
        [value]="ceilingHeight.Under_2_4M"
      >
        {{ t('createJobRequest.installLampsForm.roomHeight.standard') }}
      </cft-radio>
      <cft-radio [formControl]="form.controls.highestRoomCeiling | bgoAsFormControl" [value]="ceilingHeight.Above_2_4M">
        {{ t('createJobRequest.installLampsForm.roomHeight.nonStandard') }}
      </cft-radio>
      @if (form.controls.highestRoomCeiling.value === ceilingHeight.Above_2_4M) {
        <span
          class="text-sm text-grey-700"
          [innerHTML]="t('createJobRequest.installLampsForm.roomHeight.nonStandardHint')"
        >
        </span>
      }
      @if (form.controls.highestRoomCeiling.touched && form.controls.highestRoomCeiling.invalid) {
        <span class="error">
          {{ t('createJobRequest.installLampsForm.errors.atLeastOneOptionSelected') }}
        </span>
      }
    </div>
    <div
      class="gradual-reveal mt-2xl space-y-md"
      [class.gradual-reveal-hidden]="!form.controls.highestRoomCeiling.value || numberOfLamps === 1"
      [formGroup]="wallMaterialForm"
    >
      <label class="font-bold">{{ t('createJobRequest.installLampsForm.wallMaterial.label') }}</label>
      <bgo-option-count
        [optionCount]="wallMaterialCount"
        [itemCount]="form.controls.numberOfLamps.value"
      ></bgo-option-count>
      <div>
        <cft-checkbox class="mt-xs block" [formControl]="wallMaterialOptionControls.concrete | bgoAsFormControl">
          {{ t('createJobRequest.installLampsForm.wallMaterial.concrete') }}
        </cft-checkbox>
        @if (wallMaterialOptionControls.concrete.value) {
          <cft-number-input
            [formControl]="wallMaterialControls.concrete | bgoAsFormControl"
            [max]="wallMaterialControls.concrete.value + (numberOfLamps - wallMaterialCount)"
            [min]="0"
          ></cft-number-input>
        }
      </div>
      <div>
        <cft-checkbox [formControl]="wallMaterialOptionControls.brick | bgoAsFormControl">
          {{ t('createJobRequest.installLampsForm.wallMaterial.brick') }}
        </cft-checkbox>
        @if (wallMaterialOptionControls.brick.value) {
          <cft-number-input
            [formControl]="wallMaterialControls.brick | bgoAsFormControl"
            [max]="wallMaterialControls.brick.value + (numberOfLamps - wallMaterialCount)"
            [min]="0"
          ></cft-number-input>
        }
      </div>
      <div>
        <cft-checkbox [formControl]="wallMaterialOptionControls.plaster | bgoAsFormControl">
          {{ t('createJobRequest.installLampsForm.wallMaterial.plaster') }}
        </cft-checkbox>
        @if (wallMaterialOptionControls.plaster.value) {
          <cft-number-input
            [formControl]="wallMaterialControls.plaster | bgoAsFormControl"
            [max]="wallMaterialControls.plaster.value + (numberOfLamps - wallMaterialCount)"
            [hasWarning]="wallMaterialControls.plaster.value"
            [min]="0"
          ></cft-number-input>
        }
        @if (wallMaterialControls.plaster.value) {
          <span class="warning" [innerHTML]="t('createJobRequest.priceRange.unknownInputWarning')"></span>
        }
      </div>
      <div>
        <cft-checkbox [formControl]="wallMaterialOptionControls.wood | bgoAsFormControl">
          {{ t('createJobRequest.installLampsForm.wallMaterial.wood') }}
        </cft-checkbox>
        @if (wallMaterialOptionControls.wood.value) {
          <cft-number-input
            [formControl]="wallMaterialControls.wood | bgoAsFormControl"
            [max]="wallMaterialControls.wood.value + (numberOfLamps - wallMaterialCount)"
            [min]="0"
          ></cft-number-input>
        }
      </div>
      <div>
        <cft-checkbox [formControl]="wallMaterialOptionControls.metal | bgoAsFormControl">
          {{ t('createJobRequest.installLampsForm.wallMaterial.metal') }}
        </cft-checkbox>
        @if (wallMaterialOptionControls.metal.value) {
          <cft-number-input
            [formControl]="wallMaterialControls.metal | bgoAsFormControl"
            [max]="wallMaterialControls.metal.value + (numberOfLamps - wallMaterialCount)"
            [hasWarning]="wallMaterialControls.metal.value"
            [min]="0"
          ></cft-number-input>
        }
        @if (wallMaterialControls.metal.value) {
          <span class="warning" [innerHTML]="t('createJobRequest.priceRange.unknownInputWarning')"></span>
        }
      </div>
      <div>
        <cft-checkbox [formControl]="wallMaterialOptionControls.unknown | bgoAsFormControl">
          {{ t('createJobRequest.installLampsForm.wallMaterial.notSpecified') }}
        </cft-checkbox>
        @if (wallMaterialOptionControls.unknown.value) {
          <cft-number-input
            [formControl]="wallMaterialControls.unknown | bgoAsFormControl"
            [max]="wallMaterialControls.unknown.value + (numberOfLamps - wallMaterialCount)"
            [hasWarning]="wallMaterialControls.unknown.value"
            [min]="0"
          ></cft-number-input>
        }
        @if (wallMaterialControls.unknown.value) {
          <span class="warning" [innerHTML]="t('createJobRequest.priceRange.unknownInputWarning')"></span>
        }
      </div>
      @if (
        optionControls.wallMaterialOptions.touched &&
        optionControls.wallMaterialOptions.errors?.atLeastOneOptionSelected
      ) {
        <span class="error">
          {{ t('createJobRequest.installLampsForm.errors.atLeastOneOptionSelected') }}
        </span>
      }
      @if (
        !optionControls.wallMaterialOptions.errors?.atLeastOneOptionSelected &&
        form.controls.wallMaterial.touched &&
        form.controls.wallMaterial.errors?.notAllLampsAccountedFor
      ) {
        <span class="error">
          {{ t('createJobRequest.installLampsForm.errors.notAllLampsAccountedFor') }}
        </span>
      }
    </div>
    <div
      class="gradual-reveal mt-2xl space-y-md"
      [class.gradual-reveal-hidden]="!form.controls.highestRoomCeiling.value || numberOfLamps > 1"
    >
      <label class="font-bold">{{ t('createJobRequest.installLampsForm.wallMaterial.label') }}</label>
      <cft-radio class="mt-xs block" [formControl]="optionControls.wallMaterialSingleSelect" [value]="'concrete'">
        {{ t('createJobRequest.installLampsForm.wallMaterial.concrete') }}
      </cft-radio>
      <cft-radio [formControl]="optionControls.wallMaterialSingleSelect" [value]="'brick'">
        {{ t('createJobRequest.installLampsForm.wallMaterial.brick') }}
      </cft-radio>
      <cft-radio
        [formControl]="optionControls.wallMaterialSingleSelect"
        [value]="'plaster'"
        [hasWarning]="wallMaterialControls.plaster.value"
      >
        {{ t('createJobRequest.installLampsForm.wallMaterial.plaster') }}
      </cft-radio>
      @if (wallMaterialControls.plaster.value) {
        <span class="warning" [innerHTML]="t('createJobRequest.priceRange.unknownInputWarning')"></span>
      }
      <cft-radio [formControl]="optionControls.wallMaterialSingleSelect" [value]="'wood'">
        {{ t('createJobRequest.installLampsForm.wallMaterial.wood') }}
      </cft-radio>
      <cft-radio
        [formControl]="optionControls.wallMaterialSingleSelect"
        [value]="'metal'"
        [hasWarning]="wallMaterialControls.metal.value"
      >
        {{ t('createJobRequest.installLampsForm.wallMaterial.metal') }}
      </cft-radio>
      @if (wallMaterialControls.metal.value) {
        <span class="warning" [innerHTML]="t('createJobRequest.priceRange.unknownInputWarning')"></span>
      }
      <cft-radio
        [formControl]="optionControls.wallMaterialSingleSelect"
        [value]="'unknown'"
        [hasWarning]="wallMaterialControls.unknown.value"
      >
        {{ t('createJobRequest.installLampsForm.wallMaterial.notSpecified') }}
      </cft-radio>
      @if (wallMaterialControls.unknown.value) {
        <span class="warning" [innerHTML]="t('createJobRequest.priceRange.unknownInputWarning')"></span>
      }
    </div>
    <div
      class="gradual-reveal mt-2xl space-y-md"
      [class.gradual-reveal-hidden]="wallMaterialCount !== form.controls.numberOfLamps.value"
    >
      <label class="font-bold">{{ t('createJobRequest.installLampsForm.electricalConnections.label') }}</label>
      <cft-radio
        class="mt-xs block"
        [formControl]="electricalConnectionOptionConrols.electricalConnectionOption"
        [value]="'yes'"
      >
        {{ t('createJobRequest.installLampsForm.electricalConnections.yes') }}
      </cft-radio>
      <cft-radio
        [formControl]="electricalConnectionOptionConrols.electricalConnectionOption"
        [value]="'no'"
        [hasWarning]="electricalConnectionOptionConrols.electricalConnectionOption.value === 'no'"
      >
        {{ t('createJobRequest.installLampsForm.electricalConnections.no') }}
      </cft-radio>
      @if (electricalConnectionOptionConrols.electricalConnectionOption.value === 'no') {
        <span class="warning" [innerHTML]="t('createJobRequest.priceRange.unknownInputWarning')"></span>
      }
      <cft-radio
        [formControl]="electricalConnectionOptionConrols.electricalConnectionOption"
        [value]="'unknown'"
        [hasWarning]="electricalConnectionOptionConrols.electricalConnectionOption.value === 'unknown'"
      >
        {{ t('createJobRequest.installLampsForm.electricalConnections.dontKnow') }}
      </cft-radio>
      @if (electricalConnectionOptionConrols.electricalConnectionOption.value === 'unknown') {
        <span class="warning" [innerHTML]="t('createJobRequest.priceRange.unknownInputWarning')"></span>
      }
      @if (
        electricalConnectionOptionConrols.electricalConnectionOption.touched &&
        electricalConnectionOptionConrols.electricalConnectionOption.invalid
      ) {
        <span class="error">
          {{ t('createJobRequest.installLampsForm.errors.atLeastOneOptionSelected') }}
        </span>
      }
    </div>
    <div
      class="gradual-reveal mt-2xl space-y-md"
      [class.gradual-reveal-hidden]="
        !electricalConnectionOptionConrols.electricalConnectionOption.value || lampTypeCount === 1
      "
      [formGroup]="connectionProximityForm"
    >
      <label class="font-bold">{{ t('createJobRequest.installLampsForm.connectionProximity.label') }}</label>
      <bgo-option-count
        [optionCount]="connectionProximityCount"
        [itemCount]="form.controls.numberOfLamps.value"
      ></bgo-option-count>
      <div>
        <cft-checkbox
          class="mt-xs block"
          [formControl]="connectionProximityOptionControls.directlyAtConnection | bgoAsFormControl"
        >
          {{ t('createJobRequest.installLampsForm.connectionProximity.standard') }}
        </cft-checkbox>
        @if (connectionProximityOptionControls.directlyAtConnection.value) {
          <cft-number-input
            [formControl]="connectionProximityControls.directlyAtConnection | bgoAsFormControl"
            [max]="connectionProximityControls.directlyAtConnection.value + (numberOfLamps - connectionProximityCount)"
            [min]="0"
          ></cft-number-input>
        }
      </div>
      <div>
        <cft-checkbox [formControl]="connectionProximityOptionControls.upToOneMeter | bgoAsFormControl">
          {{ t('createJobRequest.installLampsForm.connectionProximity.nonStandard1') }}
        </cft-checkbox>
        @if (connectionProximityOptionControls.upToOneMeter.value) {
          <cft-number-input
            [formControl]="connectionProximityControls.upToOneMeter | bgoAsFormControl"
            [max]="connectionProximityControls.upToOneMeter.value + (numberOfLamps - connectionProximityCount)"
            [hasWarning]="connectionProximityControls.upToOneMeter.value"
            [min]="0"
          ></cft-number-input>
        }
        @if (connectionProximityControls.upToOneMeter.value) {
          <span class="warning" [innerHTML]="t('createJobRequest.priceRange.unknownInputWarning')"></span>
        }
      </div>
      <div>
        <cft-checkbox [formControl]="connectionProximityOptionControls.moreThanOneMeter | bgoAsFormControl">
          {{ t('createJobRequest.installLampsForm.connectionProximity.nonStandard2') }}
        </cft-checkbox>
        @if (connectionProximityOptionControls.moreThanOneMeter.value) {
          <cft-number-input
            [formControl]="connectionProximityControls.moreThanOneMeter | bgoAsFormControl"
            [max]="connectionProximityControls.moreThanOneMeter.value + (numberOfLamps - connectionProximityCount)"
            [hasWarning]="connectionProximityControls.moreThanOneMeter.value"
            [min]="0"
          ></cft-number-input>
        }
        @if (connectionProximityControls.moreThanOneMeter.value) {
          <span class="warning" [innerHTML]="t('createJobRequest.priceRange.unknownInputWarning')"></span>
        }
      </div>
      @if (
        optionControls.connectionProximityOptions.touched &&
        optionControls.connectionProximityOptions.errors?.atLeastOneOptionSelected
      ) {
        <span class="error">
          {{ t('createJobRequest.installLampsForm.errors.atLeastOneOptionSelected') }}
        </span>
      }
      @if (
        !optionControls.connectionProximityOptions.errors?.atLeastOneOptionSelected &&
        form.controls.connectionProximity.touched &&
        form.controls.connectionProximity.errors?.notAllLampsAccountedFor
      ) {
        <span class="error">
          {{ t('createJobRequest.installLampsForm.errors.notAllLampsAccountedFor') }}
        </span>
      }
    </div>
    <div
      class="gradual-reveal mt-2xl space-y-md"
      [class.gradual-reveal-hidden]="
        !electricalConnectionOptionConrols.electricalConnectionOption.value || lampTypeCount > 1
      "
    >
      <label class="font-bold">{{ t('createJobRequest.installLampsForm.connectionProximity.label') }}</label>
      <cft-radio
        class="mt-xs block"
        [formControl]="optionControls.connectionProximitySingleSelect"
        [value]="'directlyAtConnection'"
      >
        {{ t('createJobRequest.installLampsForm.connectionProximity.standard') }}
      </cft-radio>
      <cft-radio
        [formControl]="optionControls.connectionProximitySingleSelect"
        [value]="'upToOneMeter'"
        [hasWarning]="connectionProximityControls.upToOneMeter.value"
      >
        {{ t('createJobRequest.installLampsForm.connectionProximity.nonStandard1') }}
      </cft-radio>
      @if (connectionProximityControls.upToOneMeter.value) {
        <span class="warning" [innerHTML]="t('createJobRequest.priceRange.unknownInputWarning')"></span>
      }
      <cft-radio
        [formControl]="optionControls.connectionProximitySingleSelect"
        [value]="'moreThanOneMeter'"
        [hasWarning]="connectionProximityControls.moreThanOneMeter.value"
      >
        {{ t('createJobRequest.installLampsForm.connectionProximity.nonStandard2') }}
      </cft-radio>
      @if (connectionProximityControls.moreThanOneMeter.value) {
        <span class="warning" [innerHTML]="t('createJobRequest.priceRange.unknownInputWarning')"></span>
      }
    </div>
    <div
      class="gradual-reveal mt-2xl space-y-md"
      [class.gradual-reveal-hidden]="connectionProximityCount !== form.controls.numberOfLamps.value"
    >
      <label class="font-bold">{{ t('createJobRequest.installLampsForm.disposalRequired.label') }}</label>
      <cft-radio class="mt-xs block" [formControl]="form.controls.disposalRequired | bgoAsFormControl" [value]="true">
        {{ t('createJobRequest.installLampsForm.disposalRequired.yes') }}
      </cft-radio>
      <cft-radio [formControl]="form.controls.disposalRequired | bgoAsFormControl" [value]="false">
        {{ t('createJobRequest.installLampsForm.disposalRequired.no') }}
      </cft-radio>
      @if (form.controls.disposalRequired.touched && form.controls.disposalRequired.invalid) {
        <span class="error">
          {{ t('createJobRequest.installLampsForm.errors.atLeastOneOptionSelected') }}
        </span>
      }
    </div>
  </form>
</ng-container>
